import { render, staticRenderFns } from "./InsuranceCompanyEdit.vue?vue&type=template&id=9692b664&scoped=true"
import script from "./InsuranceCompanyEdit.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyEdit.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCompanyEdit.vue?vue&type=style&index=0&id=9692b664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9692b664",
  null
  
)

export default component.exports